import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { NationService } from '@services/nation';
import { DateTime } from 'luxon';
//import { DateFormat } from '@services/nation/nation.model';

export enum DateFormat {
    LongDate = 'longDate',
    LongDateTime = 'longDateTime',
    ShortDate = 'shortDate',
    ShortDateTime = 'shortDateTime',
    ShortTime = 'shortTime'
}

export type DateFormats = {
    [DateFormat.LongDate]: { format: string; placeholder: string };
    [DateFormat.LongDateTime]: { format: string; placeholder: string };
    [DateFormat.ShortDate]: { format: string; placeholder: string };
    [DateFormat.ShortDateTime]: { format: string; placeholder: string };
    [DateFormat.ShortTime]: { format: string; placeholder: string };
};

@Injectable({ providedIn: 'root' })
export class DateParserFormatter extends NgbDateParserFormatter {
    //private readonly nationService = inject(NationService);
    public dateFormats = {
        [DateFormat.LongDate]: { format: 'yyyy-MM-dd', placeholder: 'YYYY-MM-DD' },
        [DateFormat.LongDateTime]: { format: 'yyyy/MM/dd H:mm', placeholder: 'YYYY/MM/DD HH:MM' },
        [DateFormat.ShortDate]: { format: 'yy-MM-dd', placeholder: 'YY-MM-DD' },
        [DateFormat.ShortDateTime]: { format: 'yy/MM/dd H:mm', placeholder: 'YY/MM/DD HH:MM' },
        [DateFormat.ShortTime]: { format: 'HH:mm', placeholder: 'HH:MM' }
    };
    private dateDelimiter = '-';

    public parse(value: string): NgbDateStruct | null {
        //const nationConfiguration = this.nationService.getUserNationConfiguration();

        const validDate = DateTime.fromFormat(value, this.dateFormats[DateFormat.LongDate].format).isValid;
        if (validDate) {
            const date = value.split(this.dateDelimiter);
            return {
                month: parseInt(date[0], 10),
                day: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }

    public format(date: NgbDateStruct | null): string {
        if (date) {
            //const nationConfiguration = this.nationService.getUserNationConfiguration();
            const dateTime = DateTime.local(date.year, date.month, date.day);
            return dateTime.toFormat(this.dateFormats[DateFormat.LongDate].format);
        }

        return null;
    }
}
